import {ChangeDetectionStrategy, Component} from '@angular/core';
import {Store} from '@ngrx/store';
import {MatDialog} from '@angular/material/dialog';
import {IAppStore} from '@app/store';
import {SmartCommandDialogComponent} from '@toolbar/smart-command/smart-command.dialog.component';

@Component({
  selector: 'app-smart-command',
  templateUrl: './smart-command.component.html',
  styleUrls: ['./smart-command.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmartCommandComponent {
  constructor(public store: Store<IAppStore>, public dialog: MatDialog) {}

  openSmartCommandDialog() {
    this.dialog.open(SmartCommandDialogComponent);
  }
}
